import styles from './styles.module.scss'

export default function AnimatedIconValid({ className = undefined }) {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <polyline
        className={styles.validIcon}
        points="16.590 0.590, 6.000 11.170, 1.830 7.000"
        strokeWidth="2.5"
        stroke="#1168F1"
      />
    </svg>
  )
}
